import { toast } from 'react-toastify';

export const useToast = ( message: string, type?: "info" | "error" | "success" ) => {
  switch(type) {
    case 'info':
      toast.info( message, { autoClose: 3000, position: "bottom-right" });
      break;
    case 'success':
      toast.success( message, { autoClose: 3000, position: "bottom-right" });
      break;
    case 'error':
      toast.error( message, { autoClose: 3000, position: "bottom-right" });
      break;
    default:
      toast.success( message, { autoClose: 3000, position: "bottom-right" });
  }
 }
